export default __webpack_public_path__ + "static/f59faa03e3a995e96ea2f8e73b471361.webp";